<template>
  <va-modal
    :value="isOpen"
    ref="showFacilityMap"
    :showOkay="false"
    :cancelText="$t('modals.back')"
    @cancel="onCancel"
  >

    <div slot="header" class="modal-title">
      <span>{{ facility.name }}</span>
    </div>

    <GoogleMap
      :center="center"
      :locations="locations"
      :zoom="14"
      :fitBounds="false"
    />

  </va-modal>
</template>
<script>
import GoogleMap from '@/components/maps/google-maps/GoogleMap'

export default {
  props: {
    facility: {
      type: Object,
      required: true
    }
  },
  components: {
    GoogleMap
  },
  mounted: function () {
    if (this.hasLocation) {
      this.isOpen = true
    } else {
      this.showToast(this.$t('entities.facilities.missing_location', this.$store.state.errorToastOptions))
    }
  },
  computed: {
    hasLocation: function () {
      return this.facility && this.facility.address && this.facility.address.lat && this.facility.address.lng
    },
    center: function () {
      if (this.hasLocation) {
        return { lat: this.facility.address.lat, lng: this.facility.address.lng }
      }
      return null
    },
    locations: function () {
      if (this.hasLocation) {
        let contentString = `<div>
          <h5> ${this.facility.name} </h5>
          <b> ${this.$t('facility.inputs.address')}:</b>`
        if (this.facility.address.line1) {
          contentString += `<span> ${this.facility.address.line1}</span>`
        }
        if (this.facility.address.line2) {
          contentString += `<span>, ${this.facility.address.line2}</span>`
        }
        if (this.facility.address.city) {
          contentString += `<span>, ${this.facility.address.city}</span>`
        }
        if (this.facility.address.postal_code) {
          contentString += `<span>, ${this.facility.address.postal_code}</span>`
        }
        contentString += `<br>
          <b> ${this.$t('placings.coordinates')}:</b>
        `
        if (this.facility.address.lat) {
          contentString += `<span> ${this.facility.address.lat}</span>`
        }
        if (this.facility.address.lng) {
          contentString += `<span> ${this.facility.address.lng}</span>`
        }
        contentString += '</div>'

        let location = { id: this.facility.id, position: { lat: this.facility.address.lat, lng: this.facility.address.lng } }
        location.label = this.facility.name
        location.window = { content: contentString, open: true }
        return [location]
      }
      return []
    }
  },
  data: function () {
    return {
      isOpen: false
    }
  },
  methods: {
    onCancel: function () {
      this.isOpen = false
      setTimeout(() => {
        this.$emit('cancel')
      }, 500)
    }
  }
}
</script>
